import { useSaveActions } from "../../common"
import { TableName } from "../../../tables"
import { define } from "../../../utils/typeUtils"
import { Check, CheckStatus, TransactionDestinationType, TransactionSourceType } from "../state/types"
import { useCheckLoaders } from "../loaders/checkLoaders"
import { useTransactionService } from "../services/transactionService"

export const useCheckActions = () => {
    const checkLoaders = useCheckLoaders()

    const { createTransaction } = useTransactionService()
    const saveActions = useSaveActions()

    const saveCheck = (check: Check) => {
        const { save } = saveActions()
        return save(TableName.CHECKS, check) as Promise<Check>
    }

    const modifyStatus = async (
        checkId: string,
        status: CheckStatus
    ) => {
        const { loadCheck } = checkLoaders()
        const loadedCheck = define(await loadCheck(checkId))
        const check: Check = {
            ...loadedCheck,
            status
        }

        return await saveCheck(check)
    }

    const reserveCheck = (checkId: string) => {
        return modifyStatus(checkId, CheckStatus.ACTIVE_PENDING)
    }

    const endorseCheck = (checkId: string) => {
        return modifyStatus(checkId, CheckStatus.ENDORSED)
    }

    const annulCheck = (checkId: string) => {
        return modifyStatus(checkId, CheckStatus.ANNULLED)
    }

    const payWithCheck = async (
        sourceType: TransactionSourceType,
        destinationType: TransactionDestinationType,
        amount: number,
        sourceId: string,
        destinationId: string
    ) => {
        if (sourceType === TransactionSourceType.CHECK) {
            await reserveCheck(sourceId)
        }

        const transactionData = {
            sourceType,
            sourceId,
            amount,
            destinationType,
            destinationId
        }
        await createTransaction(transactionData)
    }

    const removeCheck = (id: string) => {
        const { remove } = saveActions()
        return remove(TableName.CHECKS, id)
    }

    return {
        saveCheck,
        endorseCheck,
        annulCheck,
        payWithCheck,
        removeCheck
    }
}
